import { put, takeLatest } from "redux-saga/effects";
import { httpGet } from "../../services";
import { ActionSchema } from "../actions";
import {
  ApiMetricsConst,
  GetApiMetricsArgs,
  getPerformanceDataErrorAction,
  getPerformanceDataLoadingAction,
  GetPerformanceDataSchema,
  getPerformanceDataSuccessAction,
  getRequestCountDataErrorAction,
  getRequestCountDataLoadingAction,
  getRequestCountDataSuccessAction,
  getResponseCodeDataErrorAction,
  getResponseCodeDataLoadingAction,
  getResponseCodeDataSuccessAction
} from "../actions/apiMetricsActions";

/**
 * Handlers
 */
function* getRequestCountDataHandler(args: GetApiMetricsArgs) {
  try {
    yield put(getRequestCountDataLoadingAction());
    const { startTime, apiKey, endTime, timeslice } = args;
    const response = yield httpGet("/api-metrics/request-count", {
      startTime,
      endTime,
      timeslice,
      apiKey
    });

    yield put(getRequestCountDataSuccessAction({ data: response.data }));
  } catch (e) {
    yield put(getRequestCountDataErrorAction(e.message));
  }
}

function* getResponseCodeDataHandler(args: GetApiMetricsArgs) {
  try {
    yield put(getResponseCodeDataLoadingAction());
    const { startTime, apiKey, endTime, timeslice } = args;
    const response = yield httpGet("/api-metrics/response-code", {
      startTime,
      apiKey,
      endTime,
      timeslice
    });

    if (response.code) {
      throw new Error("Error getting data. Please try again.");
    }

    yield put(getResponseCodeDataSuccessAction({ data: response.data }));
  } catch (e) {
    yield put(getResponseCodeDataErrorAction(e.message));
  }
}

function* getPerformanceDataHandler(args: GetApiMetricsArgs) {
  try {
    yield put(getPerformanceDataLoadingAction());
    const { startTime, endpoint, apiKey, endTime, timeslice } = args;
    const response: GetPerformanceDataSchema = yield httpGet(`/api-metrics/performance/${endpoint}`, {
      startTime,
      endTime,
      apiKey,
      timeslice
    });

    if (response.code) {
      throw new Error("Error getting data. Please try again.");
    }

    yield put(getPerformanceDataSuccessAction({ data: response.data }));
  } catch (e) {
    yield put(getPerformanceDataErrorAction(e.message));
  }
}

/**
 * Watchers
 */
export function* watchRequestCountData() {
  yield takeLatest(ApiMetricsConst.GET_REQUEST_COUNT_DATA, ({ payload }: ActionSchema<GetApiMetricsArgs>) => getRequestCountDataHandler(payload));
}

export function* watchGetResponseCodeData() {
  yield takeLatest(ApiMetricsConst.GET_RESPONSE_CODE_DATA, ({ payload }: ActionSchema<GetApiMetricsArgs>) => getResponseCodeDataHandler(payload));
}

export function* watchPerformanceData() {
  yield takeLatest(ApiMetricsConst.GET_PERFORMANCE_DATA, ({ payload }: ActionSchema<GetApiMetricsArgs>) => getPerformanceDataHandler(payload));
}
